import React, { Component } from 'react';
import Project from './Project'
import './App.css';

const projects = [
  {
    route:'react_authorquizz',
    title:'React Author Quizz',
  },{
    route:'books',
    title:'Books ( ES6 - React course)',
  },{
    route:'todos',
    title:'ToDos (Yeoman Demo)',
  },{
    route:'push_notifications',
    title:'Push notifications (forked from simple-push-demo)',
  },{
    route:'gcm_notifications',
    title:'Gcm notifications',
  },
]

function Projects({projects}) {
  return (
  <div className="Projects"><br/>
    {projects.map((project) => <Project {...project}/>)}
  </div>);
}

class App extends Component {
  render() {    
    return (
      <div className="App">
        <header className="App-header"><h1>Test Projects Playground</h1>
        </header>
        <body>
          <Projects projects={projects}/>
        </body>
      </div>
    );
  }
}

export default App;
